
import PortfolioUnrankInfoModal from '~/components/ui/modal/PortfolioUnrankInfoModal.vue';
import PortfolioUnrankInfoDrawer from '~/components/ui/molecule/PortfolioUnrankInfoDrawer.vue';
import { isMobileResponsive } from '@/utils/mixins';
import { getWindowInstance } from '@/plugins/windowInstance';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'PortfolioUnrankInfo',
  components: {
    PortfolioUnrankInfoModal,
    PortfolioUnrankInfoDrawer,
  },
  mixins: [isMobileResponsive],
  data() {
    return {
      buttonOptions: {
        PRIVATE: 'private',
        PUBLIC: 'public',
      },
      privacyOptions: {
        // private
        PRIVATE: 'private',
        // public
        UNLISTED: 'unlisted',
        // ranked
        PUBLIC: 'public',
      },
      initialSelectedButtonOption: null,
      selectedButtonOption: null,
      // Used for a case when the modal is closed through the modal component using closeTopModal
      shouldResetFlag: true,
    };
  },
  computed: {
    defaultButtonOption() {
      if (this.portfolioOperationConfirmationComponent.isPublic) {
        return this.buttonOptions.PUBLIC;
      } else {
        return this.buttonOptions.PRIVATE;
      }
    },
    isMobileResponsive() {
      // @ts-ignore TODO fix typescript not recognizing this
      return getWindowInstance(this).isMobileResponsive();
    },
    ...mapGetters('modals', ['portfolioOperationConfirmationComponent']),
    lineRuleLimit() {
      return this.portfolioOperationConfirmationComponent.lineRuleLimit;
    },
  },
  mounted() {
    this.initialSelectedButtonOption = this.defaultButtonOption;
    this.selectedButtonOption = this.defaultButtonOption;
  },
  beforeDestroy() {
    if (this.shouldResetFlag) {
      // Ensure the flag is reset when the component is destroyed
      this.updatePortfolioOperationLineRuleFlag(true);
    }
  },
  methods: {
    ...mapActions('modals', [
      'togglePortfolioOperationConfirmationComponent',
      'updatePortfolioOperationLineRuleFlag',
    ]),
    handleConfirm() {
      if (this.portfolioOperationConfirmationComponent.itemPayload) {
        this.$emit(
          'addItem',
          this.portfolioOperationConfirmationComponent.itemPayload
        );
        this.shouldResetFlag = false;
        this.togglePortfolioOperationConfirmationComponent({
          show: false,
        });
      }

      if (
        this.portfolioOperationConfirmationComponent.operationPayload &&
        this.portfolioOperationConfirmationComponent.itemId
      ) {
        if (
          this.portfolioOperationConfirmationComponent.operationPayload
            .operationType == 'Buy'
        ) {
          this.$emit('addOperation', {
            itemId: this.portfolioOperationConfirmationComponent.itemId,
            operationPayload:
              this.portfolioOperationConfirmationComponent.operationPayload,
            validateAllocation: true,
            transactionModalShouldStayOpen:
              this.portfolioOperationConfirmationComponent
                .transactionModalShouldStayOpen,
          });
        } else {
          this.$emit('addOperation', {
            itemId: this.portfolioOperationConfirmationComponent.itemId,
            operationPayload:
              this.portfolioOperationConfirmationComponent.operationPayload,
            validateAllocation: false,
            transactionModalShouldStayOpen:
              this.portfolioOperationConfirmationComponent
                .transactionModalShouldStayOpen,
          });
        }
        this.shouldResetFlag = false;
        this.togglePortfolioOperationConfirmationComponent({
          show: false,
        });
      }
    },
    handleClose() {
      this.togglePortfolioOperationConfirmationComponent({
        show: false,
      });
    },
  },
};
